const Quotation = {
  CreateQuotation: "Quotation.CreateQuotation",
  ReportCreateQuotation: "Quotation.ReportCreateQuotation",
  QuotationDate: "Quotation.QuotationDate",
  QuotationDateDescription: "Quotation.QuotationDateDescription",
  ExpirationDate: "Quotation.ExpirationDate",
  ExpirationDateDescription: "Quotation.ExpirationDateDescription",
  ExpirationDateControlLabel: "Quotation.ExpirationDateControlLabel",
  MailQuotation: "Quotation.MailQuotation",
  MailQuotationDescription: "Quotation.MailQuotationDescription",
  SaveSuccessMessage: "Quotation.SaveSuccessMessage",
  NewQuotation: "Quotation.NewQuotation",
  Quotation: "Quotation.Quotation",
  QuotationText: "Quotation.QuotationText",
  SendMailSuccessMessage: "Quotation.SendMailSuccessMessage",
  SendMailSubjectDescription: "Quotation.SendMailSubjectDescription",
  SendMailFromDescription: "Quotation.SendMailFromDescription",
  SendMailToDescription: "Quotation.SendMailToDescription",
  SendMailMessageDescription: "Quotation.SendMailMessageDescription",
  QuotationNumberHashTag: "Quotation.QuotationNumberHashTag",
  ReceiverDescription: "Quotation.ReceiverDescription",
  ReceiverTabContentTitle: "Quotation.ReceiverTabContentTitle",
  ContentTabContentTitle: "Quotation.ContentTabContentTitle",
  ContentDescription: "Quotation.ContentDescription",
  OtherSettingsDescription: "Quotation.OtherSettingsDescription",
  InvoiceDesign: "Quotation.InvoiceDesign",
  InvoiceDesignDescription: "Quotation.InvoiceDesignDescription",
  Won: "Quotation.Won",
  Draft: "Quotation.Draft",
  Lost: "Quotation.Lost",
  Created: "Quotation.Created",
  ViewInvoice: "Quotation.ViewInvoice",
  MailCustomer: "Quotation.MailCustomer",
  CreateInvoice: "Quotation.CreateInvoice",
  EditQuotation: "Quotation.EditQuotation",
  StateFlowState_0: "Quotation.StateFlowState_0",
  StateFlowState_1: "Quotation.StateFlowState_1",
  StateFlowState_2: "Quotation.StateFlowState_2",
  StateFlowState_3: "Quotation.StateFlowState_3",
  StateFlowState_4: "Quotation.StateFlowState_4",
  StateFlowState_5: "Quotation.StateFlowState_5",
  StateFlowState_6: "Quotation.StateFlowState_6",
  StateFlowState_100: "Quotation.StateFlowState_100",
  Download: "Quotation.Download",
  CancelWarning: "Quotation.CancelWarning",
  BannerTitleState_0: "Quotation.BannerTitleState_0",
  BannerTitleState_1: "Quotation.BannerTitleState_1",
  BannerTitleState_2: "Quotation.BannerTitleState_2",
  BannerTitleState_3: "Quotation.BannerTitleState_3",
  BannerTitleState_4: "Quotation.BannerTitleState_4",
  BannerTitleState_5: "Quotation.BannerTitleState_5",
  BannerTitleOverdue: "Quotation.BannerTitleOverdue",
  BannerHeaderState_0: "Quotation.BannerHeaderState_0",
  BannerHeaderState_1: "Quotation.BannerHeaderState_1",
  BannerHeaderState_2: "Quotation.BannerHeaderState_2",
  BannerHeaderState_3: "Quotation.BannerHeaderState_3",
  BannerHeaderState_4: "Quotation.BannerHeaderState_4",
  BannerHeaderState_5: "Quotation.BannerHeaderState_5",
  BannerHeaderOverdue: "Quotation.BannerHeaderOverdue",
  ChangeStatus: "Quotation.ChangeStatus",
  CopyAction: "Quotation.CopyAction",
  MarkAsSentWarning: "Quotation.MarkAsSentWarning",
  CancelSuccessMessage: "Quotation.CancelSuccessMessage",
  Removed: "Quotation.Removed",
  ChangeStateBeforeEdit: "Quotation.ChangeStateBeforeEdit",
  QuotationTo: "Quotation.QuotationTo",
  CustomerInvoiceTo: "Quotation.CustomerInvoiceTo",
  MailSendFromWarning: "Quotation.MailSendFromWarning",
  MarkedAsSentSuccessMessage: "Quotation.MarkedAsSentSuccessMessage",
  }
export default Quotation;